/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'image_upload': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<g transform="translate(-.125 1)" _stroke="#CBD4D8" _fill="none" fill-rule="evenodd"><circle pid="0" cx="4.405" cy="4.23" r="1.167"/><path pid="1" d="M1.555 11.715c.967-1.31 1.666-2.244 2.095-2.801.645-.837 2.012-3.221 3.24.071M6.001 10.63c.872-1.139 1.47-1.91 1.793-2.312.485-.605 1.381-2.644 3.04.317" stroke-linecap="round" stroke-linejoin="round"/><path pid="2" d="M10.66 12.417H1.339c-.188 0-.339-.144-.339-.316V.318C1 .146 1.15 0 1.339 0H7.42L10.9 3.215c.064.058.101 1.95.101.196v8.69c0 .172-.152.316-.34.316z" stroke-linecap="round" stroke-linejoin="round"/><path pid="3" stroke-linecap="round" stroke-linejoin="round" d="M7.35 0v3.69H11"/></g>'
  }
})
